// =============================================================================
// src/data/atalaia-mapping-query.ts — A query GraphQL unica do backend AtalaIA.
//
// SRP: so a string da query + o tipo da resposta. Compartilhada pelo cliente
//   runtime (src/data/atalaia-client.ts) e pelo gerador build-time
//   (scripts/atalaia-source.mjs, via re-export), garantindo UMA fonte da query.
//
// Cobertura real hoje (confirmada no banco 2026-06-17):
//   - election_results: 2016/2020/2024 = Prefeito, 2022 = Governador (2014/2018 nao
//     carregados); idh: PNUD/Atlas, mais recente 2010; eleitorado: TSE perfil 2024.
// =============================================================================

import type { AtalaiaTerritoryRow } from '../app/types';

/** Query unica: por municipio AM, insumos socioeconomicos + os 4 anos eleitorais. */
export const ATALAIA_QUERY =
  'query ExploreReal { gold_territory(where: {territory_type: {_eq: "municipality"}, uf: {_eq: "AM"}}) ' +
  '{ official_code mesoregion microregion ' +
  'electorates(order_by: {year: desc}, limit: 1) { electors } ' +
  'territory_snapshots(order_by: {year: desc}, limit: 1) { population } ' +
  'human_developments(order_by: {year: desc}, limit: 1) { idh_m per_capita_income } ' +
  'education_indicators(where: {school_type: {_in: ["pública","municipal"]}, ideb_score: {_is_null: false}, year: {_gte: 2021}}, order_by: {year: desc}) { year school_type ideb_score } ' +
  'social_programs(where: {program: {_eq: "novo_bolsa_familia"}}, order_by: {period_month: desc}, limit: 1) { beneficiaries } ' +
  'election_results(where: {year: {_in: [2016,2020,2022,2024]}, office: {_in: ["prefeito","governador"]}}, ' +
  'order_by: [{round: desc}, {votes: desc}]) { year round office party_code votes vote_pct } } }';

/** Forma da resposta `data` do Hasura para ATALAIA_QUERY. */
export interface AtalaiaGraphqlData {
  readonly gold_territory: readonly AtalaiaTerritoryRow[];
}
